export const disableBodyScroll = () => {
	const scrollY = window.scrollY

	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth

	document.body.style.position = 'fixed'
	document.body.style.top = `-${scrollY}px`
	document.body.style.width = '100%'
	document.body.style.overflow = 'hidden'

	// Add compensation padding so content doesn't shift
	if (scrollbarWidth > 0) {
		document.body.style.paddingRight = `${scrollbarWidth}px`
	}

	return scrollY
}

export const enableBodyScroll = (scrollY: number) => {
	document.body.style.position = ''
	document.body.style.top = ''
	document.body.style.width = ''
	document.body.style.overflow = ''
	document.body.style.paddingRight = ''

	window.scrollTo(0, scrollY)
}
